import { ValueItem } from './value-item';

export class DataItem {
    timestamp: number;
    values: ValueItem[];
    unspecifiedChange?: boolean;
}